<!-- 交易趋势数据(日期) -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodeList": ["2KKN885S"],
                "type": 0,
                "startDate": "20190910000000",
                "endDate": "20190910235959",
            },
            responseCode:{
                    "data": {
                        "recordList": [
                            {
                                "offlineTradingValue": 0.07,
                                "onlineTradingPrecent": "0.0%",
                                "onlineTradingValue": 0,
                                "statDate": 1568044800000,
                                "statDateStr": "2019-09-10"
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据日期范围获取交易趋势数据",
                t_url: this.commonUrls.test+"dealTrendencyByDate",
                p_url: this.commonUrls.prod+"dealTrendencyByDate",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编码数组' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '数据类型 0日 1周' },
                        { info1: 'startDate', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endDate', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'statDate', info2: '是', info3: 'long', info4: '统计日期时间戳' },
                        { info1: 'statDateStr', info2: '是', info3: 'String', info4: '统计日期格式化,yyyy-MM-dd' },
                        { info1: 'onlineTradingValue', info2: '是', info3: 'Decimal', info4: '线上交易金额' },
                        { info1: 'offlineTradingValue', info2: '是', info3: 'Decimal', info4: '线下交易金额' },
                        { info1: 'onlineTradingPrecent', info2: '是', info3: 'String', info4: '线上交易占比' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/dealTrendencyByDate.vue